import { render, staticRenderFns } from "./Subscribers.vue?vue&type=template&id=5f22e6a1&scoped=true"
import script from "./Subscribers.vue?vue&type=script&lang=js"
export * from "./Subscribers.vue?vue&type=script&lang=js"
import style0 from "./Subscribers.vue?vue&type=style&index=0&id=5f22e6a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f22e6a1",
  null
  
)

export default component.exports